export enum DocumentType {
  ARTICLE_45 = 'ARTICLE_45',
  MANAGEMENT_AGREEMENT = 'MANAGEMENT_AGREEMENT',
  MEETING_REPORT = 'MEETING_REPORT',
  IDENTITY_CARD = 'IDENTITY_CARD',
  RESIDENCY_PERMIT = 'RESIDENCY_PERMIT',
  PERMIT_REQUEST = 'PERMIT_REQUEST',
  DOMICILE_CERTIFICATE = 'DOMICILE_CERTIFICATE',
  DRIVING_LICENSE = 'DRIVING_LICENSE',
  PROXY_FORM = 'PROXY_FORM',
  INVOICE = 'INVOICE',
  REMINDER = 'REMINDER',
  SIGNED_OFFER = 'SIGNED_OFFER',
  OFFER = 'OFFER',
  POLICY = 'POLICY',
  SIGNATURE_CERTIFICATE = 'SIGNATURE_CERTIFICATE',
  CANCELLATION_LETTER = 'CANCELLATION_LETTER',
  SIGNED_CANCELLATION_LETTER = 'SIGNED_CANCELLATION_LETTER',
  OTHER = 'OTHER',
}

export const getDocumentTypeLabel = (value: DocumentType): string => {
  switch (value) {
    case DocumentType.ARTICLE_45:
      return $localize`Article 45`;
    case DocumentType.MANAGEMENT_AGREEMENT:
      return $localize`Mandat de gestion`;
    case DocumentType.MEETING_REPORT:
      return $localize`PV d'entretien`;
    case DocumentType.IDENTITY_CARD:
      return $localize`Carte d'identité`;
    case DocumentType.RESIDENCY_PERMIT:
      return $localize`Permis de séjour`;
    case DocumentType.PERMIT_REQUEST:
      return $localize`Demande de permis`;
    case DocumentType.DOMICILE_CERTIFICATE:
      return $localize`Attestation de domicile`;
    case DocumentType.DRIVING_LICENSE:
      return $localize`Permis de conduire`;
    case DocumentType.PROXY_FORM:
      return $localize`Formulaire de procuration`;
    case DocumentType.INVOICE:
      return $localize`Facture`;
    case DocumentType.REMINDER:
      return $localize`Rappel`;
    case DocumentType.SIGNED_OFFER:
      return $localize`Offre signée`;
    case DocumentType.OFFER:
      return $localize`Offre`;
    case DocumentType.POLICY:
      return $localize`Police`;
    case DocumentType.SIGNATURE_CERTIFICATE:
      return $localize`Certificat de signature`;
    case DocumentType.CANCELLATION_LETTER:
      return $localize`Lettre de résiliation`;
    case DocumentType.SIGNED_CANCELLATION_LETTER:
      return $localize`Lettre de résiliation signée`;
    case DocumentType.OTHER:
      return $localize`Autre document`;
  }
};
